import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { RequestService } from '@df/api/request/request.service';
import { Status } from '@df/core/status';
import { SizeClassDirective } from '@df/ui/common/size-class.directive';
import { ActionComponent } from '../api/action.component';
import { ResultComponent } from '../api/result.component';
import { IfSizeDirective } from '@df/ui/common/if-size.directive';

/**
 * @depreciated Not needed, if needed then use local
 */
@Component({
    selector: 'logout-button',
    templateUrl: './logout-button.html',
    standalone: true,
    imports: [ResultComponent, ActionComponent, CommonModule, SizeClassDirective, IfSizeDirective]
})
export class LogoutButtonComponent {
    /**
     * Logout action status
     */
    logoutStatus = new Status();

    /**
     * Request service
     */
    request = inject(RequestService);

    logout() {
        return this.request.submitForm(undefined, this.logoutStatus, () => this.request.nexus.customer.logout({}));
    }
}
